import { Service } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ImpersonationStateModel } from './impersonation-state.model';
import { ImpersonationStateClear, ImpersonationStateSet } from './impersonation.actions';

const DEFAULT_STATE: ImpersonationStateModel = {
  kundeID: null,
  kundeName: null,
};

@State<ImpersonationStateModel>({
  name: 'state__impersonation',
  defaults: DEFAULT_STATE,
})
@Service({ autoProvided: false })
export class ImpersonationState {
  @Selector()
  public static kundeID(state: ImpersonationStateModel): number | null {
    return state.kundeID;
  }

  @Selector()
  public static kundeName(state: ImpersonationStateModel): string | null {
    return state.kundeName;
  }

  @Selector()
  public static isImpersonating(state: ImpersonationStateModel): boolean {
    return state.kundeID != null;
  }

  @Action(ImpersonationStateSet)
  public ImpersonationStateSet(ctx: StateContext<ImpersonationStateModel>, action: ImpersonationStateSet) {
    ctx.setState({ kundeID: action.kundeID, kundeName: action.kundeName });
  }

  @Action(ImpersonationStateClear)
  public ImpersonationStateClear(ctx: StateContext<ImpersonationStateModel>) {
    ctx.setState({ ...DEFAULT_STATE });
  }
}
